import { render, staticRenderFns } from "./v-switch-simple.vue?vue&type=template&id=68d2ee78&scoped=true"
import script from "./v-switch-simple.vue?vue&type=script&lang=js"
export * from "./v-switch-simple.vue?vue&type=script&lang=js"
import style0 from "./v-switch-simple.vue?vue&type=style&index=0&id=68d2ee78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d2ee78",
  null
  
)

export default component.exports